export default __webpack_public_path__ + "static/media/Garments.8dabb9ae.png";